import React, { Component } from 'react'
import styles from './AudioGallery.css'

/*const numberSort = (a, b) => a - b*/

const mod = (offset, offsets) => {
  for (var i = 0; i < offsets.length; i++) {
    if (offset < offsets[i]) {
      return Math.max(0, i - 1)
    }
  }
  return offsets.length - 1
}

export default class AudioGallery extends Component {
  constructor (props) {
    super(props)
    this.audios = (new Array(this.props.audio.length)).fill(0)
    this.state = {
      currentlyPlaying: null,
      audioProgress: (new Array(this.audios.length)).fill(0),
      width: document.body.offsetWidth * 0.8,
      offset: document.body.offsetWidth * 0.1,
      isLoading: (new Array(this.audios.length)).fill(true),
    }
    this.currentAudio = 0
    this.canTriggerClick = true
    this.velocity = 0
    this.lastClientX = null
    this.offsets = this.props.audio.map((audio, i) => (
      document.body.offsetWidth * 0.1 + i * (document.body.offsetWidth * 0.8 + 20)
    ))
    this.currentAudioOverride = false
  }
  componentDidMount () {
    this.interval = setInterval(this.tryUpdate, 60)
    this.intervalForce = setInterval(this.tryUpdateForce, 60)
    window.addEventListener('resize', this.handleResize)
    this.tryUpdateWidth()

    this.handleAudioLoads = (new Array(this.audios.length)).fill(0).map((x, i) => this.handleAudioLoad(i))

    this.audios.forEach((audio, i) => {
      audio.volume = 0
      audio.play()
      console.log('playing',audio)
      audio.addEventListener("canplaythrough", this.handleAudioLoads[i], true);
      audio.onended = () => {
        this.setState({currentlyPlaying: null})
      }
    })
  }
  componentWillUnmount () {
    window.clearInterval(this.interval)
    window.clearInterval(this.intervalForce)
    window.removeEventListener('resize', this.handleResize)
    this.tickingWidth = false
    this.tickingForce = false
    this.tickingAudioChange = false
    this.tickingKinetic = false
    this.ticking = false
  }
  handleAudioLoad = (i) => (e) => {
    e.target.pause()
    e.target.volume = 1
    e.target.removeEventListener("canplaythrough", this.handleAudioLoads[i], true)
    this.setState({isLoading: this.state.isLoading.map((x, j) => j == i ? false : x)})
    console.log('pausin',e.target)
    e.target.currentTime = 0.00001
  }
  handleResize = () => {
    if (!this.tickingResize) {
      this.tickingResize = true
      this.updateResize()
    }
  }
  updateResize = () => {
    if (this.tickingResize) {
      this.offsets = this.props.audio.map((audio, i) => (
        document.body.offsetWidth * 0.1 + i * (document.body.offsetWidth * 0.8 + 20)
      ))
      this.tryUpdateWidth()
      this.tickingResize = false
    }
  }
  tryUpdateWidth = () => {
    if (!this.tickingWidth) {
      this.tickingWidth = true
      this.updateWidth()
    }
  }
  updateWidth = () => {
    if (this.tickingWidth) {
      this.setState({width: document.body.offsetWidth * 0.8})
      this.tickingWidth = false
    }
  }

  tryUpdateForce = () => {
    if (!this.tickingForce) {
      this.tickingForce = true
      this.updateForce()
    }
  }

  updateForce = () => {
    if (this.tickingForce && !this.state.isDragging) {
      const distToCurrentAudio = -this.state.offset - ((this.currentAudioOverride !== false ? this.currentAudioOverride : this.currentAudio) * (document.body.offsetWidth * 0.8 + 20)) + document.body.offsetWidth * 0.1
      this.velocity += -distToCurrentAudio / 10
      this.velocity *= Math.abs(1 / (1 + Math.exp(-distToCurrentAudio*5)) - 0.5)
      this.requestUpdateKinetic()
    }
    this.tickingForce = false
  }

  bindAudio = (c, i) => {
    this.audios[i] = c
  }
  onPlayPauseClick = (index) => {
    if (this.canTriggerClick) {
      let wasPaused = this.audios[index].paused
      this.audios.forEach(x => x.pause())
      this.setState({currentlyPlaying: null})
      if (wasPaused) {
        this.audios[index].play()
        this.setState({currentlyPlaying: index})
      }
    }
  }
  tryUpdate = () => {
    if (!this.ticking) {
      window.requestAnimationFrame(this.update)
      this.ticking = true
    }
  }
  update = () => {
    if (this.ticking) {
      this.setState({audioProgress: this.state.audioProgress.map((progress, i) => this.audios[i].currentTime / this.audios[i].duration)})
      this.ticking = false
    }
  }

  handleMouseDown = (event) => {
    this.currentAudioOverride = false
    this.setState({ isDragging: true })
    this.lastClientX = event.touches ? event.touches[0].clientX : event.clientX
    this.mouseStart = this.lastClientX
    this.canTriggerClick = true
  }

  handleMouseMove = (event) => {
    if (this.state.isDragging) {
      if (Math.abs(this.velocity) > 0.5) {
        this.canTriggerClick = false
      }

      const clientX = event.touches ? event.touches[0].clientX : event.clientX
      this.velocity = this.lastClientX - clientX
      this.lastClientX = clientX
      this.requestUpdateKinetic()
    }
  }

  handleMouseUp = () => {
    this.setState({ isDragging: false })
  }
  handleMouseLeave = () => this.setState({ isDragging: false })

  requestUpdateKinetic = () => {
    if (!this.tickingKinetic) {
      this.tickingKinetic = true
      requestAnimationFrame(this.updateKinetic)
    }
  }

  tryAudioChange = () => {
    if (!this.tickingAudioChange) {
      this.tickingAudioChange = true
      window.requestAnimationFrame(this.doAudioChange)
    }
  }

  doAudioChange = () => {
    if (this.tickingAudioChange) {
      this.props.onAudioChange(this.props.audio[this.currentAudio])
      this.tickingAudioChange = false
    }
  }

  updateKinetic = () => {
    if (this.tickingKinetic) {
      const lastWidth = document.body.offsetWidth * 0.8
      const offset = Math.max(-(this.state.width + 20) * this.props.audio.length + lastWidth + document.body.offsetWidth * 0.1 + 20,
                       Math.min(document.body.offsetWidth * 0.1,
                         this.state.offset - this.velocity))
      this.setState({
        offset: offset,
      })

      if (!this.currentAudioOverride && this.state.isDragging) {
        if (this.velocity < -2 && this.currentAudio > 0) {
          this.currentAudioOverride = this.currentAudio - 1
        }
        else if (this.velocity > 2 && this.currentAudio < this.props.audio.length - 1) {
          this.currentAudioOverride = this.currentAudio + 1
        }
      }
      this.currentAudio = mod(-offset + (document.body.offsetWidth * 0.6 + 10), this.offsets)
      this.tryAudioChange()
      this.velocity *= 0.9
      this.tickingKinetic = false
      if (Math.abs(this.velocity) >= 0.01) {
        this.requestUpdateKinetic()
      }
      else {
        this.currentAudioOverride = false
      }
      if (this.currentAudioOverride == this.currentAudio) {
        this.currentAudioOverride = false
      }
    }
  }



  handleDotClick = (i) => {
    this.currentAudioOverride = i
    this.tryUpdateForce()
  }

  bindCaptionElement = (c) => {
    this.props.bindCaptionElement(c)
  }

  handleLeftClick = () => {
    const currentAudio = this.currentAudioOverride === false ? this.currentAudio : this.currentAudioOverride
    this.currentAudioOverride = (currentAudio - 1 + this.props.audio.length) % this.props.audio.length
  }

  handleRightClick = () => {
    const currentAudio = this.currentAudioOverride === false ? this.currentAudio : this.currentAudioOverride
    this.currentAudioOverride = (currentAudio + 1 + this.props.audio.length) % this.props.audio.length
  }

  render () {
    return (
      <div className={styles.cont}>
        <div ref={this.bindCaptionElement} className={styles.captionCont +' '+ (this.props.fixCaptions ? styles.fixCaptions : '')}>
          {this.props.audio.map((audio, i) => (
            this.state.currentlyPlaying == i && audio.captions
            .filter(caption => (
              caption.start < this.audios[i].currentTime * 1000 && caption.end > this.audios[i].currentTime * 1000
            ))
            .map((caption, i) => (
              <div key={i} className={styles.caption}>
                {caption.text}
              </div>
            ))
          ))}
        </div>


        <div className={styles.audioGalleryCont}>
          {this.props.audio.length > 1 && (
            <div>
              <div className={styles.galleryArrow +' '+ styles.arrowLeft} onClick={this.handleLeftClick}/>
              <div className={styles.galleryArrow +' '+ styles.arrowRight} onClick={this.handleRightClick}/>
            </div>
          )}
          <div className={styles.slidingCont}>
            <div
              className={styles.sliding}
              style={{
                width: (this.state.width + 20) * this.props.audio.length,
                transform: 'translateX('+this.state.offset+'px)',
              }}
              onMouseDown={this.handleMouseDown}
              onMouseMove={this.handleMouseMove}
              onMouseUp={this.handleMouseUp}
              onMouseLeave={this.handleMouseLeave}
              onTouchStart={this.handleMouseDown}
              onTouchMove={this.handleMouseMove}
              onTouchEnd={this.handleMouseUp}
              onTouchCancel={this.handleMouseUp}
            >
              {this.props.audio.map((audio, i) => (
                <div key={i} className={styles.audioCont}>
                  <audio preload={'auto'} ref={(c) => this.bindAudio(c, i)}>
                    <source src={audio.mp3} type="audio/mp3"/>
                    <source src={audio.ogg} type="audio/ogg"/>
                  </audio>
                  <AudioView
                    audio={audio}
                    audioIndex={i}
                    isLoading={this.state.isLoading[i]}
                    onPlayPauseClick={this.onPlayPauseClick}
                    isPaused={this.state.currentlyPlaying !== i}
                    progress={this.state.audioProgress[i]}
                    time={this.audios[i].currentTime}
                    width={this.state.width}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.dotsCont}>
          {this.props.audio.length > 1 && (
            this.props.audio.map((audio, i) => (
              <Dot key={i} index={i} currentAudio={this.currentAudioOverride !== false ? this.currentAudioOverride : this.currentAudio} onClick={this.handleDotClick}/>
            ))
          )}
        </div>
      </div>
    )
  }
}

class Dot extends Component {
  handleClick = () => {
    this.props.onClick(this.props.index)
  }
  render () {
    return (
      <div className={styles.dotCont} onClick={this.handleClick}>
        <div className={styles.dot +' '+ (this.props.currentAudio == this.props.index ? styles.activeDot : '')}/>
      </div>
    )
  }
}

class AudioView extends Component {
  handleClick = () => {
    this.props.onPlayPauseClick(this.props.audioIndex)
  }
  render () {
    return (
      <div className={styles.audioView} style={{
        width: this.props.width
      }}>
        <div className={styles.audioViewInner}>
          <PlayControl isLoading={this.props.isLoading} isPaused={this.props.isPaused} onClick={this.handleClick} progress={this.props.progress}/>
          <div className={styles.audioDescriptionCont}>
            <div className={styles.audioDescription} dangerouslySetInnerHTML={{__html:this.props.audio.description}}/>
          </div>
        </div>
      </div>
    )
  }
}

class PlayControl extends Component {
  handleClick = () => {
    if (!this.props.isLoading) {
      this.props.onClick()
    }
  }
  render () {
    return (
      <div className={styles.playControlCont} onClick={this.props.onClick}>
        <div className={styles.playControl}>
          <div className={styles.arc}>
            {this.props.progress ? (
              <Arc degrees={this.props.progress * 360} radius={147}/>
            ) : null}
          </div>
          <div className={styles.screen}/>
          {
            this.props.isLoading ? (
              <div className={styles.playControlIcon +' '+ styles.loadingIcon}/>
            ) : (
              <div
                className={
                  styles.playControlIcon
                  +' '+
                  (this.props.isLoading ? styles.loadingIcon
                    : this.props.isPaused ? styles.playIcon
                    : styles.pauseIcon)
                }
              />
            )
          }
        </div>
      </div>
    )
  }
}


const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  }
};

const describeSlice = (x, y, radius, startAngle, endAngle) => {

    const start = polarToCartesian(x, y, radius, endAngle)
    const end = polarToCartesian(x, y, radius, startAngle)

    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1"

    const d = [
        "M", 0, 0, start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" ")

    return d
};

const path = (degrees = 90, radius = 10) => {
    return describeSlice(0, 0, radius, 0, degrees) + 'Z'
}

const Arc = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <g transform="translate(150,150)" stroke="rgba(0,0,0,0)" strokeWidth="0">
      <path d={path(props.degrees, props.radius)} fill="#e44c99"/>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/Rist/modules/TourWork/AudioGallery/index.js